import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef
} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import { toast } from "react-toastify";

import OverLoading from "../global/OverLoading";
import { addCategory } from "../../actions/admin/category";
import { toggleModal } from "../../actions/modal";

const FormCreate = forwardRef(({ addCategory, toggleModal }, ref) => {
  const submitButtonRef = useRef();

  useImperativeHandle(ref, () => ({
    submitForm() {
      submitButtonRef.current.click();
    }
  }));

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    group: ""
  });

  const { name, group } = formData;

  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      await addCategory(formData).then((response) => {
        if( response.status === 200 ){
          setLoading(false);
          toast.success("Category Created.");
        }else{
          toast.error("An unexpected error has occurred");
        }
      });
    } catch (err) {
      toast.error(err);
    }

    toggleModal();
  };

  return (
    <form
      className="form position-relative"
      onSubmit={e => onSubmit(e)}
      autoComplete="off"
    >
      {loading && <OverLoading />}
      <div className="form-group">
        <label className="col-form-label">Name *</label>
        <TextField name="name" className="form-control" value={name} multiline={true} onChange={e => onChange(e)} />
      </div>
      <div className="form-group">
        <label className="col-form-label">Group *</label>
        <input
          type="text"
          className="form-control"
          name="group"
          value={group}
          onChange={e => onChange(e)}
          required
        />
      </div>
      <div className="form-group">
        <input
          type="submit"
          className="btn btn-primary mr-1 d-none"
          value="Save"
          ref={submitButtonRef}
        />
      </div>
    </form>
  );
});

FormCreate.propTypes = {
  addCategory: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired
};

export default connect(null, { addCategory, toggleModal }, null, {
  forwardRef: true
})(FormCreate);
